export default {"src":"/_next/static/media/ra-aircraft-balo.2233a55f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};